import script from "./SectionBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionBanner.vue?vue&type=script&setup=true&lang=js"

import "./SectionBanner.vue?vue&type=style&index=0&id=2c954b9d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c954b9d"]])

export default __exports__